import React from 'react';

interface CoverLetterIconProps {
  className?: string;
  size?: number;
}

const CoverLetterIcon: React.FC<CoverLetterIconProps> = ({ className = "", size = 24 }) => {
  return (
    <img
      src="/images/icons8-letter-64.png"
      alt="Cover Letter Icon"
      width={48}
      height={48}
      className={`${className} w-12 h-12`}
    />
  );
};

export default CoverLetterIcon;
